module.exports = new __parcel__URL__("jsm-calendar.205c9141.svg").toString();